import React from 'react';
import {useFormik} from "formik";

import {useAuthentication} from "../../Auth";
import {newPasswordValidationSchema} from "../../services/password/validator";
import {useFeedbackTools} from "../../components/FeedbackTools";
import PasswordField from "../../components/PasswordField";

import {Navigate, useSearchParams} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";


const PasswordChangePage = () => {
    const {resetPassword} = useAuthentication();
    const {showErrorNotification} = useFeedbackTools();
    const [isLoading, setIsLoading] = React.useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const formik = useFormik({
        initialValues: {
            password: "",
            passwordConfirmation: ""
        },
        validationSchema: newPasswordValidationSchema,
        onSubmit: async (values) => {
            const {password, passwordConfirmation} = values;
            setIsLoading(true);
            try {
                await resetPassword(token, password, passwordConfirmation);
            } catch (e) {
                showErrorNotification(e);
                setIsLoading(false);
            }
        },
    });

    const disableSave = Object.keys(formik.errors).some(x => formik.touched[x]);

    // If token is null or empty redirect to home page
    if (!token) {
        return <Navigate to="/" replace/>
    }

    return (
        <React.Fragment>
            <Box component="form"
                 noValidate
                 onSubmit={formik.handleSubmit}
                 sx={{mt: 1, width: "100%"}}>

                <Typography gutterBottom>
                    Inserisci la nuova password
                </Typography>

                <PasswordField
                    autoComplete="new-password"
                    margin="normal"
                    required
                    fullWidth
                    label="Nuova password"
                    name="password"
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}/>

                <PasswordField
                    autoComplete="new-password"
                    margin="normal"
                    required
                    fullWidth
                    label="Conferma nuova password"
                    name="passwordConfirmation"
                    onChange={formik.handleChange}
                    value={formik.values.passwordConfirmation}
                    error={formik.touched.passwordConfirmation && Boolean(formik.errors.passwordConfirmation)}
                    helperText={formik.touched.passwordConfirmation && formik.errors.passwordConfirmation}/>

                <LoadingButton
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={disableSave}
                    sx={{mt: 3, mb: 2}}
                    loading={isLoading}>
                    Cambia password
                </LoadingButton>
            </Box>
        </React.Fragment>
    );
};

export default PasswordChangePage;